/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlPostTestingUserResponse } from './ControlPostTestingUserResponse';
import {
    ControlPostTestingUserResponseFromJSON,
    ControlPostTestingUserResponseFromJSONTyped,
    ControlPostTestingUserResponseToJSON,
} from './ControlPostTestingUserResponse';

/**
 * 
 * @export
 * @interface ControlPostTestingCreateClientResponse
 */
export interface ControlPostTestingCreateClientResponse {
    /**
     * 
     * @type {string}
     * @memberof ControlPostTestingCreateClientResponse
     */
    client_id: string;
    /**
     * 
     * @type {string}
     * @memberof ControlPostTestingCreateClientResponse
     */
    org_id?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlPostTestingCreateClientResponse
     */
    entity_ids: Array<string>;
    /**
     * 
     * @type {Array<ControlPostTestingUserResponse>}
     * @memberof ControlPostTestingCreateClientResponse
     */
    users: Array<ControlPostTestingUserResponse>;
}

/**
 * Check if a given object implements the ControlPostTestingCreateClientResponse interface.
 */
export function instanceOfControlPostTestingCreateClientResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "client_id" in value;
    isInstance = isInstance && "entity_ids" in value;
    isInstance = isInstance && "users" in value;

    return isInstance;
}

export function ControlPostTestingCreateClientResponseFromJSON(json: any): ControlPostTestingCreateClientResponse {
    return ControlPostTestingCreateClientResponseFromJSONTyped(json, false);
}

export function ControlPostTestingCreateClientResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlPostTestingCreateClientResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'client_id': json['client_id'],
        'org_id': !exists(json, 'org_id') ? undefined : json['org_id'],
        'entity_ids': json['entity_ids'],
        'users': ((json['users'] as Array<any>).map(ControlPostTestingUserResponseFromJSON)),
    };
}

export function ControlPostTestingCreateClientResponseToJSON(value?: ControlPostTestingCreateClientResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'client_id': value.client_id,
        'org_id': value.org_id,
        'entity_ids': value.entity_ids,
        'users': ((value.users as Array<any>).map(ControlPostTestingUserResponseToJSON)),
    };
}

